<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <div class="条件区">
        <app-wmsm-Rtconditions  [show]="true"  [ShowVendor]="true" [ShowPANo]="false" [ShowRNO]="true"  [ShowPONO]="true" [ShowAutopaNo]="true" [ShowBillingStatus]="false" [ShowTime]="true"[QueryFromRT]="onQueryClick()" (listenForm)="getFormValue($event)"></app-wmsm-Rtconditions>
      </div>
        <!-- <div nz-col nzPush="10" *ngIf="isShowCondition">
            <button nz-button style="left: 28px;" class="default-button" nzType="primary" (click)="onSearch()">{{
              "Query" | translate}}</button>
        </div> -->
    </div>
    <div class="信息区" style="float: right" ></div>

    <nz-card>
    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <div class="表格" >
      <nz-table #colSpanTable [nzData]="listOfData"  style="margin-bottom: 10px"
        nzSize="middle" nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
        [nzPageIndex]='pageIndex' [nzScroll]="{ y: '600px',x:'2000px' }">
        <thead>
          <tr>
            <th scope="col" nzWidth="60px">{{ "table.Site" | translate}}</th>
            <th scope="col" nzWidth="100px">{{ "table.Buyer" | translate}}</th>
            <!-- <th scope="col" nzWidth="65px">{{ "StatementMonth" | translate}}</th> -->
            <th scope="col" nzWidth="65px">{{ "StatementDate" | translate}}</th>
            <th scope="col" nzWidth="100px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{ "StatementNo" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "VendorCode" | translate}}</th>
            <th scope="col" nzWidth="100px">{{ "VendorName" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "SupplierWindow" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "AutoPaNo" | translate}}</th>
            <th scope="col" nzWidth="80px">{{ "AutoPaMsg" | translate}}</th>


          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data;let i=index">
            <td>{{data.siteName}}</td>
            <td>{{data.buyerName}}</td>
            <!-- <td>{{data.acMonth}}</td> -->
            <td>{{data.acDate}}</td>
            <td>
              <a *ngIf="data.autoPaNo" nz-popconfirm nzPopconfirmTitle="{{'AUTOPA' | translate}}" nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="confirm(data)" (nzOnCancel)="RnoOnClick(data.aotuPaNo)"      
                 nzOkText="{{'detail' | translate}}"
                nzCancelText="AUTO PA">
                {{data.rNo}}
              </a>
              <a *ngIf="data.autoPaNo==null || data.autoPaNo==''" nz-popconfirm nzPopconfirmTitle="{{'LookDetail' | translate}}" nzPopconfirmPlacement="bottom"
              (nzOnConfirm)="confirm(data)" (nzOnCancel)="cancel()"      
               nzOkText="{{'detail' | translate}}"
              nzCancelText="cancel" >
              {{data.rNo}}
            </a>

              <!-- <span *ngIf="data.autoPaNo" class="linkLabel" (click)="RnoOnClick(data.aotuPaNo)" style="text-decoration:underline;color:blue">
                {{data.rNo}}
              </span>
             <div *ngIf="data.autoPaNo==null" >
                {{data.rNo}}
             </div> -->
            </td>
            <td>{{data.vendorCode}}</td>
            <td>{{data.vendorName}}</td>
            <td>{{data.vc}}</td>
            <td>{{data.autoPaNo}}</td>
            <td>{{data.autoPaErrorMsg}}</td>

          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
        (nzPageSizeChange)="nzPageSizeChange($event)" 
        (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
        <ng-template #renderItemTemplate let-type let-page="page">
         
          <a *ngIf="type === 'page'">{{ page }}</a>
          <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
          <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
        </ng-template>
    </div>
  </nz-card>
  </div>
</nz-spin>

<nz-modal [(nzVisible)]="isVisible" nzTitle="{{'InvoiceInfo' | translate}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" nzOkText="{{'Ok'|translate}}" nzCancelText="{{'cancel'|translate}}" >
  <ng-container *nzModalContent>
  
  <nz-table #colSpanTable [nzData]="listOfGoodsData"  nzSize="middle"
  [nzFrontPagination]="false" [nzShowPagination]='false' [nzScroll]="{ y: '400px',x:'800px' }" >
    <thead>
      <tr>
        <th scope="col" nzWidth="80px">{{ "InvoiceSerialNumber" | translate}}</th>
        <th scope="col" nzWidth="100px">{{ "InvoiceDate" | translate}}</th>
        <th scope="col" nzWidth="150px">{{ "InvoiceCode" | translate}}</th>
        <th scope="col" nzWidth="150px" style="text-align: center;">{{ "InvoiceNo" | translate}}</th>
        <th scope="col" nzWidth="120px">{{ "InvoiceAmountBeforeTax" | translate}}</th>
        <th scope="col" nzWidth="100px">{{ "Taxes" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr  *ngFor="let data of listOfGoodsData;let i=index">
        <td >{{data.invoiceItem}}</td>
        <td>{{data.invoiceDate | date:'yyyy-MM-dd'}}</td>
        <td >{{data.invoiceCode}}</td>
        <td >{{data.invoice}}</td>
        <td style="text-align: right; word-break:break-all;" >{{data.invoiceAmount}}</td>
        <td style="text-align: right; word-break:break-all;" >{{data.taxAmount}}</td>
      </tr>
    </tbody>
  </nz-table>
</ng-container>
</nz-modal>